/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Injectable} from '@angular/core';

const maxSmallScreenSize = 768;
const maxMediumScreenSize = 1279;

@Injectable({
  providedIn: 'root',
})
export class WindowSizeService {
  static windowSizeSmall(): boolean {
    return window.innerWidth <= maxSmallScreenSize;
  }

  static windowSizeMedium(): boolean {
    return (
      maxSmallScreenSize < window.innerWidth &&
      window.innerWidth <= maxMediumScreenSize
    );
  }

  static windowSizeLarge(): boolean {
    return maxMediumScreenSize < window.innerWidth;
  }
}
